export default __webpack_public_path__ + "static/media/qr-templated-seacharge.d068d506.png";